import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { StaggerGroup, fadeUp } from "@/components/motion/Reveal";
import Icon from "@/components/Icon";
import { SERVICES } from "@/data/services";

// Reusable service card grid (home + services page).
export default function ServicesGrid({ withHeading = true }) {
  return (
    <section className="section-pad" data-testid="services-section">
      <div className="container-sky">
        {withHeading && (
          <SectionHeading
            align="center"
            eyebrow="What We Do"
            title="Comprehensive Safety Consultancy & Training"
            description="Six specialised areas covering the full spectrum of workplace safety, fire safety, emergency preparedness and training."
            className="mb-14"
          />
        )}

        <StaggerGroup className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s) => (
            <motion.div key={s.slug} variants={fadeUp()} data-testid={`service-card-${s.id}`}>
              <Link
                to={`/services/${s.slug}`}
                className="card-light group flex h-full flex-col p-7 sm:p-8"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-brand/10 to-brand-light/15 text-brand transition-colors duration-300 group-hover:from-brand group-hover:to-brand group-hover:text-white">
                    <Icon name={s.icon} className="h-7 w-7" />
                  </span>
                  <span className="font-mono-tech text-2xl font-bold text-slate-200 transition-colors group-hover:text-brand-light">
                    {s.id}
                  </span>
                </div>
                <h3 className="mt-6 font-heading text-xl font-bold leading-snug text-navy">
                  {s.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{s.excerpt}</p>
                <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-ink">
                  Learn More
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </Link>
            </motion.div>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
